import Timestamp from './Timestamp';
import { Money } from '../utils/currency';

export enum BillingItemType {
  SUBSCRIPTION = 'SUBSCRIPTION',
  RECURRING = 'RECURRING',
  USAGE = 'USAGE',
  ONE_TIME = 'ONE_TIME',
}

interface BillingItemBase {
  id: string;
  type: BillingItemType;
  createdAt: Timestamp;
  quantity: number;
  unitPrice: Money;
  discount: number;
  taxRate: number;
  createdBy: string;
  isDemo: boolean;
}

export interface SubscriptionBillingItem extends BillingItemBase {
  type: BillingItemType.SUBSCRIPTION;
  subscriptionId: string;
  startDate: string;
  endDate?: string | null;
  paidUntil?: string | null;
}

interface RecurringBillingItem extends BillingItemBase {
  type: BillingItemType.RECURRING;
  recurringType: string;
  reference: string;
  startDate: string;
  endDate?: string | null;
  paidUntil?: string | null;
}

interface UsageBillingItem extends BillingItemBase {
  type: BillingItemType.USAGE;
  usageType: string;
  period: string;
}

interface OneTimeBillingItem extends BillingItemBase {
  type: BillingItemType.ONE_TIME;
  datePaid: string;
  name: string;
}

export type BillingItem =
  | SubscriptionBillingItem
  | RecurringBillingItem
  | UsageBillingItem
  | OneTimeBillingItem;
